var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "table",
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._l(_vm.residences, function(residence) {
          return _c("tr", { key: residence.id }, [
            _c("td", [_vm._v(_vm._s(residence.name))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(residence.availability.name))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(residence.price) + ",-")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(residence.size) + "m²")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(residence.bedrooms.name))])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Navn:")]),
        _vm._v(" "),
        _c("th", [_vm._v("Salgsstatus:")]),
        _vm._v(" "),
        _c("th", [_vm._v("Pris:")]),
        _vm._v(" "),
        _c("th", [_vm._v("BRA:")]),
        _vm._v(" "),
        _c("th", [_vm._v("Soverom:")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }